import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's110g-s110m02',
    templateUrl: './s110g-s110m02.component.html'
})
export class S110gS110m02Component extends Overlay {
    dfh0114: any = {};
    dfh0115: any = {};
    dfh0116: any = {};
    dfh0117: any = {};
    dfh0118: any = {};
    dfh0119: any = {};
    dfh0120: any = {};
    dfh0121: any = {};
    dfh0122: any = {};
    dfh0123: any = {};
    dfh0124: any = {};
    dfh0125: any = {};
    dfh0126: any = {};
    dfh0127: any = {};
    dfh0128: any = {};
    dfh0129: any = {};
    dfh0130: any = {};
    dfh0131: any = {};
    dfh0132: any = {};
    dfh0133: any = {};
    dfh0134: any = {};
    dfh0135: any = {};
    dfh0136: any = {};
    dfh0137: any = {};
    dfh0138: any = {};
    dfh0139: any = {};
    dfh0140: any = {};
    dfh0141: any = {};
    dfh0142: any = {};
    dfh0143: any = {};
    dfh0144: any = {};
    dfh0145: any = {};
    dfh0146: any = {};
    dfh0147: any = {};
    dfh0148: any = {};
    dfh0149: any = {};
    dfh0150: any = {};
    dfh0151: any = {};
    dfh0152: any = {};
    dfh0153: any = {};
    dfh0154: any = {};
    dfh0155: any = {};
    dfh0156: any = {};
    dfh0157: any = {};
    dfh0158: any = {};
    dfh0159: any = {};
    dfh0160: any = {};
    dfh0161: any = {};
    dfh0162: any = {};
    dfh0163: any = {};
    dfh0164: any = {};
    dfh0165: any = {};
    dfh0166: any = {};
    dfh0167: any = {};
    dfh0168: any = {};
    dfh0169: any = {};
    dfh0170: any = {};
    dfh0171: any = {};
    dfh0172: any = {};
    dfh0173: any = {};
    dfh0174: any = {};
    dfh0175: any = {};
    dfh0176: any = {};
    dfh0177: any = {};
    dfh0178: any = {};
    dfh0179: any = {};
    dfh0180: any = {};
    dfh0181: any = {};
    dfh0182: any = {};
    dfh0183: any = {};
    dfh0184: any = {};
    dfh0185: any = {};
    dfh0186: any = {};
    dfh0187: any = {};
    dfh0188: any = {};
    dfh0189: any = {};
    dfh0190: any = {};
    dfh0191: any = {};
    dfh0192: any = {};
    dfh0193: any = {};
    dfh0194: any = {};
    dfh0195: any = {};
    dfh0196: any = {};
    dfh0197: any = {};
    dfh0198: any = {};
    dfh0199: any = {};
    dfh0200: any = {};
    dfh0201: any = {};
    dfh0202: any = {};
    dfh0203: any = {};
    dfh0204: any = {};
    dfh0205: any = {};
    dfh0206: any = {};
    dfh0207: any = {};
    dfh0208: any = {};
    dfh0209: any = {};
    dfh0210: any = {};
    dfh0211: any = {};
    dfh0212: any = {};
    dfh0213: any = {};
    dfh0214: any = {};
    dfh0215: any = {};
    dfh0216: any = {};
    dfh0217: any = {};
    dfh0218: any = {};
    dfh0219: any = {};

    public FIELDS: string[] = ['dfh0114', 'dfh0115', 'dfh0116', 'dfh0117', 'dfh0118', 'dfh0119', 'dfh0120', 'dfh0121', 'dfh0122', 'dfh0123', 'dfh0124', 'dfh0125', 'dfh0126', 'dfh0127', 'dfh0128', 'dfh0129', 'dfh0130', 'dfh0131', 'dfh0132', 'dfh0133', 'dfh0134', 'dfh0135', 'dfh0136', 'dfh0137', 'dfh0138', 'dfh0139', 'dfh0140', 'dfh0141', 'dfh0142', 'dfh0143', 'dfh0144', 'dfh0145', 'dfh0146', 'dfh0147', 'dfh0148', 'dfh0149', 'dfh0150', 'dfh0151', 'dfh0152', 'dfh0153', 'dfh0154', 'dfh0155', 'dfh0156', 'dfh0157', 'dfh0158', 'dfh0159', 'dfh0160', 'dfh0161', 'dfh0162', 'dfh0163', 'dfh0164', 'dfh0165', 'dfh0166', 'dfh0167', 'dfh0168', 'dfh0169', 'dfh0170', 'dfh0171', 'dfh0172', 'dfh0173', 'dfh0174', 'dfh0175', 'dfh0176', 'dfh0177', 'dfh0178', 'dfh0179', 'dfh0180', 'dfh0181', 'dfh0182', 'dfh0183', 'dfh0184', 'dfh0185', 'dfh0186', 'dfh0187', 'dfh0188', 'dfh0189', 'dfh0190', 'dfh0191', 'dfh0192', 'dfh0193', 'dfh0194', 'dfh0195', 'dfh0196', 'dfh0197', 'dfh0198', 'dfh0199', 'dfh0200', 'dfh0201', 'dfh0202', 'dfh0203', 'dfh0204', 'dfh0205', 'dfh0206', 'dfh0207', 'dfh0208', 'dfh0209', 'dfh0210', 'dfh0211', 'dfh0212', 'dfh0213', 'dfh0214', 'dfh0215', 'dfh0216', 'dfh0217', 'dfh0218', 'dfh0219'];
    public LINES: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

    ngAfterViewInit(): void {
    }
}
